import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, IconButton, Typography } from "@mui/material"
import { AutoFixHigh, CloudDownload, InfoOutlined } from "@mui/icons-material"
import { isEmpty } from "lodash"
import ConfirmIntegrationDialog from "../confirm-integration-dialog"
import Logo from "components/logo"
import { STATUSES } from "modules/platform/constants"
import withNavigate from "hocs/withNavigate"
import OPTooltip from "components/material/tooltip"

import "./style.scss"

const { NONE, ACTIVE } = STATUSES

function AIIntegration({ account, openDialog, closeDialog, aiIntegrationPermission, terms, termsVersion, legalAccountName, isAiPermissionGranted, isSuperuser }) {
  const [status, setStatus] = useState()
  const termsLink = `https://assets.ompnt.com/terms/AI_Integration_Permissions.v${termsVersion}.pdf`

  useEffect(() => {
    setStatus(isAiPermissionGranted ? ACTIVE : NONE)
  }, [isAiPermissionGranted])

  const isButtonDisabled = isEmpty(legalAccountName) || isSuperuser
  function confirm() {
    openDialog({
      title: <div id="ai-integration-dialog-header">
        <Typography variant="h6">Omega Point Artificial Intelligence Permissions</Typography>
        <IconButton
          className="download"
          color="secondary"
          variant="contained"
          component="a"
          target="_blank"
          href={termsLink}
          download
          size="large"
        >
          <CloudDownload />
        </IconButton>
      </div>,
      content: <ConfirmIntegrationDialog closeDialog={closeDialog} confirm={enableAI} termsText={terms} />,
    })
  }

  function enableAI(legalText) {
    aiIntegrationPermission(account, window.location.href, legalText)
    closeDialog()
  }

  return <div id="ai-integration" className="app-card integration">
    <Logo />
    <div className="header">
      <div className="name-wrapper">
        <div className="name">Omega Point Artificial Intelligence</div>
      </div>
    </div>
    <div className="body">
      <p className="description">Enable AI-powered co-pilot within the Omega Point platform, generating personalized, narrative-based insights.</p>
      {status !== ACTIVE ? <Button disabled={isButtonDisabled} color="primary" className="confirm" onClick={confirm}>Activate</Button>
        : <OPTooltip title={<div>
          Look for the <AutoFixHigh fontSize="small" /> icon when looking at a portfolio to access the Omega Point Artificial Intelligence.
        </div>}
        >
          <span><Button disabled variant="outlined" endIcon={<InfoOutlined />}>Activated</Button></span>
        </OPTooltip>}
    </div>
  </div>
}

AIIntegration.propTypes = {
  account: PropTypes.string.isRequired,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  aiIntegrationPermission: PropTypes.func.isRequired,
  isAiPermissionGranted: PropTypes.bool.isRequired,
  terms: PropTypes.string,
  termsVersion: PropTypes.number,
  legalAccountName: PropTypes.string,
  isSuperuser: PropTypes.bool.isRequired,
  navigate: PropTypes.func.isRequired,
}

export default withNavigate(AIIntegration)
